export default __webpack_public_path__ + "static/media/logo-marvel.49357f07.svg";